import { render } from "./GastronomyHeader.vue?vue&type=template&id=2354ffe3&scoped=true"
import script from "./GastronomyHeader.vue?vue&type=script&lang=js"
export * from "./GastronomyHeader.vue?vue&type=script&lang=js"

import "./GastronomyHeader.vue?vue&type=style&index=0&id=2354ffe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2354ffe3"]])

export default __exports__